export default "__VITE_ASSET__Dxc0qsT0__"